module.exports = __webpack_public_path__ + "img/dark-grey.725254a6.png";